import * as React from 'react'
import { createContext, useContext, useState, ReactNode } from 'react'
import FloatingChatBalloon from '../Components/Chat/FloatingChatBalloon.jsx'

interface ChatContextType {
    isChatOpen: boolean
    isChatEnabled: boolean
    setIsChatOpen: React.Dispatch<React.SetStateAction<boolean>>
    chatData: Record<string, any> | null
    setChatData: React.Dispatch<
        React.SetStateAction<Record<string, any> | null>
    >
}

const ChatContext = createContext<ChatContextType | undefined>(undefined)

export const useChat = (): ChatContextType => {
    const context = useContext(ChatContext)
    if (!context) throw new Error('useChat must be used within a ChatProvider')
    return context
}

interface ChatProviderProps {
    children: ReactNode
    kedo: any
}

export const ChatProvider = ({
    children,
    kedo,
    isChatEnabled,
}: ChatProviderProps) => {
    const [isChatOpen, setIsChatOpen] = useState(false)
    const [chatData, setChatData] = useState<Record<string, any> | null>(null)

    return (
        <ChatContext.Provider
            value={{
                isChatOpen,
                setIsChatOpen,
                chatData,
                setChatData,
                isChatEnabled,
            }}
        >
            {children}
            {isChatEnabled && <FloatingChatBalloon kedo={kedo} />}
        </ChatContext.Provider>
    )
}
